import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Observable } from 'rxjs';

import { SharedModule } from '@app/shared/shared.module';

import { ChatLayerComponent } from './components/chat-layer/chat-layer.component';
import { FinancialCartComponent } from './components/financial-cart/financial-cart.component';
import { FooterVerticalStepComponent } from './components/stepper/footer-vertical-step/footer-vertical-step.component';
import { LogoPlaceholderComponent } from './components/logo-placeholder/logo-placeholder.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { ToogleSwitchComponent } from './components/toogle-switch/toogle-switch.component';

const httpLoaderFactory = (http: HttpClient): TranslateHttpLoader => new TranslateHttpLoader(http, './assets/i18n/', '.json');

class AppMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams): string {
        return `[Missing translation for key:  ${params.key}]`;
    }
}

@Injectable()
export class TranslationInitPreload {
    constructor(private readonly translateService: TranslateService) {}

    init(): Observable<void> {
        return this.translateService.use(this.translateService.defaultLang);
    }
}

export const loadTranslations = (translationInitPreload: TranslationInitPreload) => (): Observable<void> => translationInitPreload.init();

@NgModule({
    imports: [
        HeaderComponent,
        StepperComponent,
        FooterComponent,
        ChatLayerComponent,
        FinancialCartComponent,
        LogoPlaceholderComponent,
        FooterVerticalStepComponent,
        ToogleSwitchComponent,
        SharedModule
    ],
    providers: [],
    exports: [
        HeaderComponent,
        StepperComponent,
        FooterComponent,
        ChatLayerComponent,
        FinancialCartComponent,
        LogoPlaceholderComponent,
        FooterVerticalStepComponent,
        ToogleSwitchComponent
    ],
})
export class CoreModule {}
